import axios from "axios";
import {
  BASE_URL,
  SENDING_CONFIRMATION_EMAIL,
  SENDING_CONFIRMATION_EMAIL_FAILURE,
  SENDING_CONFIRMATION_EMAIL_SUCCESSFUL
} from "../../constants";

export function sendConfirmationEmail(payload) {
  // Production code
  return function(dispatch) {
    dispatch({ type: SENDING_CONFIRMATION_EMAIL });

    const url = `${BASE_URL}/email/downpaymentsuccess`;

    // Fetch trip
    axios
      .post(url, payload)
      .then(results => {
        dispatch({
          type: SENDING_CONFIRMATION_EMAIL_SUCCESSFUL,
          payload: results.data
        });
        history.push("reservations");
      })
      .catch(err => {
        let error = "Error while sending downpayment email (client)";
        if (err.response) {
          const { status, data } = err.response;
          if (status !== 200) {
            error = data;
          }
        }

        dispatch({
          type: SENDING_CONFIRMATION_EMAIL_FAILURE,
          payload: error
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/scenes/ReservationsPage/actions.js